import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FolderOpen, MessageSquare, FileText, Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const [stats, setStats] = useState({ projects: 0, testimonials: 0, blogPosts: 0 });
  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    const headers = { Authorization: `Bearer ${token}` };
    Promise.all([
      axios.get(`${API}/api/admin/projects`, { headers }),
      axios.get(`${API}/api/admin/testimonials`, { headers }),
      axios.get(`${API}/api/admin/blog`, { headers }),
    ]).then(([projRes, testRes, blogRes]) => {
      setStats({ projects: projRes.data.length, testimonials: testRes.data.length, blogPosts: blogRes.data.length });
    });
  }, [token]);

  return (
    <div className="p-8" data-testid="admin-dashboard">
      <h1 className="text-3xl font-bold text-white mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <Card className="bg-gray-900 border-gray-800">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-400">Total Projects</CardTitle>
            <FolderOpen className="text-orange-500" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-white" data-testid="stat-projects">{stats.projects}</div>
          </CardContent>
        </Card>

        <Card className="bg-gray-900 border-gray-800">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-400">Total Reviews</CardTitle>
            <MessageSquare className="text-orange-500" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-white" data-testid="stat-testimonials">{stats.testimonials}</div>
          </CardContent>
        </Card>

        <Card className="bg-gray-900 border-gray-800">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-400">Blog Posts</CardTitle>
            <FileText className="text-orange-500" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-white" data-testid="stat-blog">{stats.blogPosts}</div>
          </CardContent>
        </Card>

        <Card className="bg-gray-900 border-gray-800">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-400">Quick Actions</CardTitle>
            <Plus className="text-orange-500" size={20} />
          </CardHeader>
          <CardContent>
            <Link
              to="/admin/projects?action=new"
              className="inline-flex items-center space-x-2 bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg text-sm transition-colors"
              data-testid="quick-add-project"
            >
              <Plus size={16} />
              <span>New Project</span>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminDashboard;
